<template>
  <CCard>
    <CCardHeader>
      <slot name="header">
        <CIcon name="cil-group"/> {{caption}}
        <div class="card-header-actions">
          <CButton color="info" size="sm" @click="storeModal()">Nuevo Impuesto</CButton>
        </div>
      </slot>
    </CCardHeader>
    <CCardBody>
      <CDataTable 
        :hover="hover"
        :striped="striped"
        :border="border"
        :small="small"
        :fixed="fixed"
        :items="items"
        :fields="fields"
        :items-per-page="small ? 10 : 5"
        :dark="dark"
        pagination
      >
        <template #name="{item}"><td>{{item.name}}{{item.factor == 'EXENTO' ? ' Exento' : ''}}</td></template>
        <template #type="{item}"><td class="w200 text-center">{{item.type == "RETENCION" ? "RETENCIÓN" : item.type}}</td></template>
        <template #rate="{item}"><td class="w200 text-center">{{ (item.rate * 100).toFixed(2) }}%</td></template>
        <template #actions="{item}">
          <td class="table_actions b2">
            <CButton color="warning" size="sm" @click="updateModal(item)"><CIcon name="cil-pencil"/></CButton>
            <CButton color="danger" size="sm" @click="deleteModal(item)"><CIcon name="cil-trash"/></CButton>
          </td>
        </template>
      </CDataTable>
    </CCardBody>
    <TaxModal ref="taxModal" @store="storeProcess" @update="updateProcess"></TaxModal>
    <DeleteModal ref="deleteModal" @delete="deleteProcess"></DeleteModal>
  </CCard>
</template>

<script>
import TaxModal from './TaxModal.vue'
import DeleteModal from '../../global/DeleteModal.vue'
import ws from '../../../services/taxes';
import store from '../../../store'

export default {
  name: 'TaxesTable',
  components: { TaxModal, DeleteModal }, 
  props: {
    items: Array,
    fields: {
      type: Array,
      default () {
        return [
          {key: 'name', label: 'Impuesto'},
          {key: 'type', label: 'Tipo'},
          {key: 'rate', label: 'Porcentaje'},
          {key: 'actions', label: 'Acciones', class: 'actions' },
        ]
      }
    },
    caption: {
      type: String,
      default: 'Table'
    },
    hover: Boolean,
    striped: Boolean,
    border: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean
  },
  data() {
    return {
      toasts: []
    }
  },
  methods: {
    storeModal () {
      this.$refs.taxModal.storeModal();
    },
    updateModal (item) {
      this.$refs.taxModal.updateModal(item);
    },
    deleteModal (item) {
      this.$refs.deleteModal.show("Eliminar Impuesto", item.id, item.name);
    },
    async storeProcess(data) {
      let response = await ws.store(data);
      
      if(response.type == "success"){
        this.$emit("refreshTaxes", response.data );
      }

      this.showToast(response.type, response.message);
    },
    async updateProcess(data) {
      let response = await ws.update(data);

      if(response.type == "success"){
        this.$emit("refreshTaxes", response.data );
      }

      this.showToast(response.type, response.message);
    },
    async deleteProcess(id) {
      let response = await ws.delete(id);
      
      if(response.type == "success"){
        this.$emit("refreshTaxes", response.data );
      }

      this.showToast(response.type, response.message);
    },
    showToast(type, message){
      store.commit('toast', {color: type, message: message});
    },
    loading(){
      store.commit('loading');
    },
    loaded(){
      store.commit('loaded');
    },
  }
}
</script>
